<div mat-dialog-title class="mat-dialog-title">
  <div class="user-photo" *ngIf="!usingCamera && !webcamImage">
    <span>{{ 'photo' | translate }}</span>
    <button mat-icon-button mat-dialog-close>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div class="user-choice" *ngIf="usingCamera">
    <div class="user-choice">
      <button mat-icon-button (click)="declineImage()">
        <mat-icon class="back-arrow" svgIcon="arrow-left"></mat-icon>
      </button>
      <span>{{ 'new_photo' | translate }}</span>
    </div>
    <button *ngIf="cameraAvailable && multipleWebcamsAvailable" mat-icon-button class="btn-flip-camera" (click)="showNextWebcam(true)">
      <mat-icon svgIcon="switch-camera"></mat-icon>
    </button>
  </div>
  <div class="user-choice" *ngIf="webcamImage">
    <button mat-icon-button (click)="declineImage()">
      <mat-icon class="back-arrow" svgIcon="arrow-left"></mat-icon>
    </button>
    <span>{{ 'use_photo_?' | translate }}</span>
  </div>
</div>
<div mat-dialog-content>
  <div class="webcam" *ngIf="usingCamera && !webcamImage">
    <div *ngIf="cameraAvailable" #webcamChild>
      <webcam
        [height]="400"
        [width]="350"
        [trigger]="trigger$"
        (imageCapture)="webcamImage = $event"
        [allowCameraSwitch]="false"
        [switchCamera]="nextWebcam$"
        [videoOptions]="videoOptions"
        [imageQuality]="1"
        (cameraSwitched)="cameraWasSwitched($event)"
        (initError)="handleInitError($event)"
      ></webcam>
      <div class="webcam-overlay">
        <svg class="line">
          <path
            d="M 0 0 L 0 350 L 350 262.34 L 350 0 L 0 0 z M 35 35 L 320 35 L 320 232.34 L 35 232.34 L 35 35 z"
            style="opacity: 0.5; stroke-width: 1; fill: white"
          ></path>
          <g id="topleft">
            <!-- top left corner -->
            <line x1="30" y1="30" x2="90" y2="30"></line>
            <line x1="30" y1="30" x2="30" y2="90"></line>
          </g>
          <g id="topright">
            <!-- top right corner -->
            <line x1="260" y1="30" x2="320" y2="30"></line>
            <line x1="320" y1="30" x2="320" y2="90"></line>
          </g>
          <g id="bottomleft">
            <!-- bottom left corner -->
            <line x1="30" y1="172.34" x2="30" y2="232.34"></line>
            <line x1="30" y1="232.34" x2="90" y2="232.34"></line>
          </g>
          <g id="bottomright">
            <!-- bottom right corner -->
            <line x1="320" y1="172.34" x2="320" y2="232.34"></line>
            <line x1="260" y1="232.34" x2="320" y2="232.34"></line>
          </g>
        </svg>
      </div>
    </div>
    <div class="missing-camera" *ngIf="!cameraAvailable">
      <mat-icon svgIcon="camera-off"></mat-icon>
    </div>
  </div>
  <div *ngIf="!usingCamera">
    <div *ngIf="webcamImage">
      <img [src]="webcamImage.imageAsDataUrl" />
    </div>
    <div *ngIf="!webcamImage">
      <img [src]="currentImage | safe" />
    </div>
  </div>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-between">
  <div>
    <div *ngIf="!webcamImage" class="web-cam-actions">
      <input type="file" hidden class="file-upload" accept="image/*" (change)="onFileChange($event.target.files)" #fileUpload />
      <button mat-stroked-button color="primary" class="outlined" *ngIf="data.upload" (click)="fileUpload.click()">
        <mat-icon svgIcon="upload"></mat-icon>
        <span>{{ 'upload' | translate }}</span>
      </button>
      <button *ngIf="!cameraAvailable" mat-raised-button color="primary" (click)="cameraUnavailable()">
        <mat-icon svgIcon="camera-off"></mat-icon>
        {{ 'unavailable' | translate }}
      </button>
      <button *ngIf="cameraAvailable" mat-raised-button color="primary" (click)="triggerSnapshot()">
        <mat-icon svgIcon="camera-plus"></mat-icon>
        {{ usingCamera ? ('take_photo' | translate) : ('new_photo' | translate) }}
      </button>
    </div>
    <div *ngIf="webcamImage" class="web-cam-actions confirm">
      <button mat-raised-button color="primary" (click)="acceptImage()">
        <mat-icon svgIcon="check"></mat-icon>
        {{ 'yes' | translate }}
      </button>
      <button mat-stroked-button color="primary" class="outlined" (click)="declineImage()">
        <mat-icon svgIcon="close"></mat-icon>
        {{ 'no' | translate }}
      </button>
    </div>
  </div>
  <button *ngIf="!usingCamera && !webcamImage && hasPicture" mat-icon-button (click)="resetImage()" class="btn-reset-photo">
    <mat-icon svgIcon="trash-can"></mat-icon>
  </button>
</div>
